import type React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootReducerType } from '../../../../redux/reducers/RootReducer.types';
import Spinner from '../../../layout/Spinner/Spinner';

type Props = {
  'data-test-id'?: string;
  className?: string;
  children: React.ReactNode;
};

const MessageActionButtonsContainer = ({
  children,
  className,
  'data-test-id': dataTestId,
}: Props) => {
  const { onUpdateAppointment } = useSelector(
    (state: RootReducerType) => state.appointment,
  );

  const { getConversationNewMessagesResponse } = useSelector(
    (state: RootReducerType) => state.chat,
  );

  const [onUpdate, setOnUpdate] = useState<boolean>(false);

  useEffect(() => {
    if (onUpdateAppointment && !onUpdate) {
      setOnUpdate(true);
    }
  }, [onUpdateAppointment]);

  useEffect(() => {
    if (getConversationNewMessagesResponse && onUpdate) {
      setOnUpdate(false);
    }
  }, [getConversationNewMessagesResponse]);

  return (
    <span
      className="mt-6 flex min-w-full flex-col items-center justify-center gap-2"
      data-test-id={dataTestId}
    >
      {onUpdate ? (
        <span
          className={
            className ||
            'flex size-full min-h-14 min-w-full flex-col items-center justify-center'
          }
        >
          <Spinner color="fill-slate-500" />
        </span>
      ) : (
        children
      )}
    </span>
  );
};

export default MessageActionButtonsContainer;
